module.exports = __webpack_public_path__ + "static/media/DSC_2689-HDR.712af342.jpg";